import { ENV } from "../utils";

export class Accident {
  baseApi = ENV.BASE_API;

  async getAccidents(accessToken, filters = true) {
    const params = new URLSearchParams();
    if (typeof filters === "boolean") {
      params.append("active", filters);
    } else {
      if (filters.active !== undefined) params.append("active", filters.active);
      if (filters.site)                 params.append("site",   filters.site);
    }
    const url = `${this.baseApi}/accidents?${params.toString()}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async getAccident(accessToken, id) {
    const response = await fetch(`${this.baseApi}/accident/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createAccident(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-accident`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateAccident(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-accident/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteAccident(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-accident/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async uploadFile(accessToken, id, formData) {
    const response = await fetch(`${this.baseApi}/accident/${id}/upload-file`, {
      method: "POST",
      body: formData,
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async getFile(accessToken, fileName) {
    const response = await fetch(`${this.baseApi}/accident-file/${fileName}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) return null;
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  }

  async deleteFile(accessToken, id, fileName) {
    const response = await fetch(`${this.baseApi}/accident/${id}/delete-file`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify({ fileName }),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
